import { render, staticRenderFns } from "./regressionTitle.vue?vue&type=template&id=200aa630&scoped=true"
import script from "./regressionTitle.vue?vue&type=script&lang=js"
export * from "./regressionTitle.vue?vue&type=script&lang=js"
import style0 from "./regressionTitle.vue?vue&type=style&index=0&id=200aa630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200aa630",
  null
  
)

export default component.exports